<template>
    <div class="col-12">
        <h3>{{ vehicle.id > 0 ? (vehicle.license_plate + ' - ' + vehicle.make + ' ' + vehicle.vehicle_model) : $t('vehicle.add') }}</h3>
        <div class="nopads">
            <ul
                class="nav nav-tabs routa-tabs"
                role="tablist"
            >
                <li class="nav-item">
                    <button
                        class="routa-tab"
                        :class="{ active: tabIndex === 0 }"
                        :style="linkTabClass(0)"
                        @click="tabIndex = 0"
                    >
                        {{ $t('contracts.basic_info') }}
                    </button>
                </li>
                <li class="nav-item">
                    <button
                        class="routa-tab"
                        :class="{ active: tabIndex === 1 }"
                        :style="linkTabClass(1)"
                        @click="tabIndex = 1"
                    >
                        {{ $t('menu.inspections') }}
                    </button>
                </li>
                <li class="nav-item">
                    <button
                        class="routa-tab"
                        :class="{ active: tabIndex === 2 }"
                        :style="linkTabClass(2)"
                        @click="tabIndex = 2"
                    >
                        {{ $t('menu.fleet_defects') }}
                    </button>
                </li>
                <li class="nav-item">
                    <button
                        class="routa-tab"
                        :class="{ active: tabIndex === 3 }"
                        :style="linkTabClass(3)"
                        @click="tabIndex = 3"
                    >
                        {{ $t('menu.fleet_trips') }}
                    </button>
                </li>
                <li class="nav-item">
                    <button
                        class="routa-tab"
                        :class="{ active: tabIndex === 4 }"
                        :style="linkTabClass(2)"
                        @click="tabIndex = 4"
                    >
                        {{ $t('menu.vehicle_sensors') }}
                    </button>
                </li>
            </ul>
            <div class="tab-content routa-tab-content">
                <div
                    v-show="tabIndex === 0"
                    class="tab-pane fade show active"
                >
                    <vehicle-statistic
                        v-if="vehicle.id > 0"
                        :vehicle="vehicle"
                    />
                    <vehicle-editor
                        :vehicle="vehicle"
                        :close-when-update="true"
                        :user="user"
                        @close="$emit('close')"
                        @added="$emit('closeAndUpdate')"
                    />
                </div>
                <div
                    v-show="tabIndex === 1"
                    class="tab-pane fade show active"
                    style="min-height: 80vh"
                >
                    <vehicle-inspections :vehicle="vehicle" />
                </div>
                <div
                    v-show="tabIndex === 2"
                    class="tab-pane fade show active"
                    style="min-height: 80vh"
                >
                    <vehicle-defects
                        :is-observer="isObserver"
                        :vehicle="vehicle"
                        @search-results="setDefectData"
                    />
                </div>
                <div
                    v-show="tabIndex === 3"
                    class="tab-pane fade show active"
                    style="min-height: 80vh"
                >
                    <trips :vehicle-id="vehicle.id" />
                </div>
                <div
                    v-show="tabIndex === 4"
                    class="tab-pane fade show active"
                    style="min-height: 80vh"
                >
                    <vehicle-sensors :vehicle="vehicle" />
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import {vehicleHelper} from '../../mixins/VehicleMixin'
import {restApi} from '../../mixins/RestApiMixin'
import Trips from "@/components/trip/Trips.vue";
import VehicleDefects from "@/components/vehicle/defect/VehicleDefects.vue";
import VehicleEditor from "@/components/vehicle/VehicleEditor.vue";
import VehicleStatistic from "@/components/vehicle/statistic/VehicleStatistic.vue";
import VehicleSensors from './VehicleSensors.vue';
import VehicleInspections from "@/components/vehicle/tabbed/VehicleInspections";
import vehicleDefectSummary from "@/components/vehicle/defect/VehicleDefectSummary.vue";

export default {
    name: 'VehicleTabbed',
    components: {
        VehicleInspections,
        VehicleStatistic,
        VehicleEditor,
        VehicleDefects,
        vehicleDefectSummary,
        Trips,
        VehicleSensors
    },
    mixins: [vehicleHelper, restApi],
    props: {
        vehicle: {
            type: Object,
            default: null
        },
        user: {
            type: Object,
            default: null
        },
        editMode: Boolean,
        isObserver: Boolean,
    },
    data: function () {
        return {
            tabIndex: 0,
            defect: null,
            lastSearchedParams: null,
            inspection: {},
            defects: [],
            vehicleID: -1,
            newVehicleUi: true,
            defectData: null,
        }
    },

    methods: {

        setDefectData: function (data) {
            this.defectData = data;
        },

        fetchDefects: function () {
            this.loading = true
            this.lastSearchedParams = {vehicle: this.vehicle.id}
            this.results = []
            let url = this.vehicleDefectUrl
            this.restFetchParams(url, this.lastSearchedParams, this.handleDefectResponse)
        },

        handleDefectResponse: function (response) {
            this.defects = response.data
            this.loading = false
        },

        closeAndUpdate: function () {
            this.showDefectList()
            this.fetchDefects(this.lastSearchedParams)
        },

        linkTabClass(index) {
            if (this.tabIndex === index) {
                return ['tab-title', 'tab-title-active']
            } else {
                return ['tab-title']
            }
        },

    }

}
</script>
